import React from "react";
import { Modal } from "antd";
import WeaDialog from "../../wea-dialog";
import WeaTools from "../../wea-tools";
import { getLabel } from "../../wea-locale-provider/util";

export default class GroupDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      optParams: {}
    };
  }
  opsHandler = (ops, e, item) => {
    const { dataParams = {} } = this.props;
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    let optParams = {};
    if (ops == "delete") {
      Modal.confirm({
        title: getLabel(131329, "信息确认"),
        content: getLabel(385625, "确定要删除选择的记录吗？"),
        onOk: () => {
          WeaTools.callApi("/api/hrm/group/delete", "POST", {
            cmd: "base",
            groupid: item.id,
            f_weaver_belongto_userid: dataParams.f_weaver_belongto_userid || ""
          })
            .then(res => {
              if (res.status === "1") {
                const { getGrouptree } = this.props;
                getGrouptree && getGrouptree();
              }
            })
            .catch(e => this.props.onError && this.props.onError(e));
        }
      });
    } else {
      optParams = {
        ops: ops,
        groupId: item.id,
        groupType: item.isPrivate === "true" ? 0 : 1,
        visible: true
      };
    }
    this.setState({ optParams });
  };
  render() {
    const { icon, iconBgcolor, dataParams = {} } = this.props;
    const { optParams } = this.state;
    const { groupType, groupId, visible = false, ops } = optParams;
    let dialogProps = {
      icon,
      iconBgcolor,
      visible
    };
    const cancelHandler = () => this.setState({ optParams: {} });
    if (ops == "advice") {
      const adviceGroupUrl = `/spa/hrm/static/index.html#/main/hrm/groupAdvice?groupId=${groupId}`;
      // 公共组调整建议弹框
      dialogProps = {
        ...dialogProps,
        title: getLabel("126253", "公共组调整建议"),
        style: { width: 650, height: 360 },
        url: adviceGroupUrl,
        onCancel: cancelHandler,
        callback: cancelHandler
      };
    } else if (ops == "add" || ops == "edit") {
      const fId = dataParams.f_weaver_belongto_userid || "";
      const createGroupUrl = `/spa/hrm/index_mobx.html#/main/hrm/operateGroup?groupType=${groupType}`;
      const editGroupUrl = `/spa/hrm/index_mobx.html#/main/hrm/operateGroup?groupId=${groupId}`;
      let groupUrl = ops == "add" ? createGroupUrl : editGroupUrl;
      if (fId) groupUrl += `&f_weaver_belongto_userid=${fId}`;
      // 新建 编辑常用组弹框
      dialogProps = {
        ...dialogProps,
        title:
          ops == "add"
            ? getLabel("386496", "新建常用组")
            : getLabel("126252", "常用组设置"),
        style:
          ops == "add"
            ? { width: 650, height: 225 }
            : { width: 750, height: 482 },
        url: groupUrl,
        onCancel: cancelHandler,
        callback: type =>
          this.setState({
            optParams: type ? { ...optParams, ops: "edit" } : {}
          })
      };
    }
    return <WeaDialog {...dialogProps} />;
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/components/GroupDialog.js